import { ApiConnector, GET, POST, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/ltv');
    return {
        GetLTV: async () => await API(GET, '').call(),
    };
})();
